export enum TradingProcedureNotificationTypeDto {
    TradingProcedurePublished = 'TradingProcedurePublished',
}
